var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 19.493,
    viewBox: "0 0 24.001 19.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.534,8.239c.015.213.015.426.015.64a13.9,13.9,0,0,1-14,14A13.9,13.9,0,0,1,0,20.666a10.176,10.176,0,0,0,1.188.061,9.851,9.851,0,0,0,6.107-2.1,4.928,4.928,0,0,1-4.6-3.411,6.2,6.2,0,0,0,.929.076,5.2,5.2,0,0,0,1.294-.167A4.92,4.92,0,0,1,.975,10.295v-.061a4.954,4.954,0,0,0,2.223.624A4.926,4.926,0,0,1,1.675,4.279,13.982,13.982,0,0,0,11.818,9.427,5.553,5.553,0,0,1,11.7,8.3a4.924,4.924,0,0,1,8.513-3.366,9.685,9.685,0,0,0,3.122-1.188,4.906,4.906,0,0,1-2.163,2.711A9.861,9.861,0,0,0,24,5.7a10.574,10.574,0,0,1-2.467,2.543Z",
    transform: "translate(0 -3.381)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.e09dbe3ae5a58638f3821759f05950a7.svg";
export { ForwardRef as ReactComponent };